import axios from 'axios';
import conf from '../config';
import SsoApi from './SsoApi';

axios.defaults.baseURL = `${conf.smsgwMessagingUrl}/api`;

export default class BaseApi extends SsoApi {
  static getFile(urlPath, cancelToken) {
    return axios({
      method: 'GET',
      url: urlPath,
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel',
          'X-Client-Bin': this.bin,
        Authorization: `Bearer ${this.token}`,
      },
      cancelToken
    });
  }
  // static downloadFile(urlPath, type, cancelToken) {
  //   return axios({
  //     method: 'GET',
  //     url: urlPath,
  //     headers: Object.assign({},
  //       { 'Accept': `application/${type}` }, this.token
  //         ? {Authorization: 'Bearer ' + this.token} : {}),
  //     responseType: 'blob',
  //     cancelToken
  //   });
  // }
  static get(urlPath, cancelToken) {
    return axios({
      method: 'GET',
      url: urlPath,
      headers: {
        'X-Client-Bin': this.bin,
        Authorization: `Bearer ${this.token}`
      },
      cancelToken
    });
  }
  static post(urlPath, data, cancelToken) {
    return axios({
      method: 'POST',
      url: urlPath,
      data,
      headers: {
        'X-Client-Bin': this.bin,
        Authorization: `Bearer ${this.token}`
      },
      cancelToken
    });
  }
  static put(urlPath, data, cancelToken) {
    return axios({
      method: 'PUT',
      url: urlPath,
      data,
      headers: {
        'X-Client-Bin': this.bin,
        Authorization: `Bearer ${this.token}`
      },
      cancelToken
    });
  }
  static delete(urlPath, cancelToken) {
    return axios({
      method: 'DELETE',
      url: urlPath,
      headers: {
        'X-Client-Bin': this.bin,
        Authorization: `Bearer ${this.token}`
      },
      cancelToken
    });
  }
}
